import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { connect } from 'react-redux';
import { modalActions } from '../../../../Actions';
import { inputHelper } from '../../../../Helpers';
import styles from './applicability.module.scss';
import Tag from '../../../Tag/Tag';
import NonApplicableProdCategoryModal from '../../../Modals/ApplicabilityModal/NonApplicableProdCategoryModal';

const NonApplicableCategory = (props) => {
	const {
		fields,
		isDisabled,
		toggleNonApplicableProductCategoriesModal,
		handleConfirm,
	} = props;
	const handleClick = () => {
		toggleNonApplicableProductCategoriesModal(true);
	};
	const handleDelete = (e) => {
		const { dataset } = inputHelper(e);
		props.handleDelete(dataset.id, 'nonapplicableCategories', 'id');
	};
	const generateTags = (allTags, type) => {
		return allTags.map((tag) => {
			return (
				<Tag
					className={`${styles.tag}`}
					handleDelete={handleDelete}
					text={tag.productCategoryName}
					isDisabled={isDisabled}
					dataAttrs={{
						'data-type': type,
						'data-id': tag.id,
						'data-name': 'nonapplicableCategories',
					}}
				/>
			);
		});
	};
	return (
		<div className={`${styles.root} ${isDisabled ? styles.disabled : ''}`}>
			<div className='form-field row'>
				<label className='form-label'>
					Non Applicable Product Categories
				</label>
				<div className={`${styles['tag-wrapper']}`}>
					{fields.nonapplicableCategories &&
						generateTags(
							fields.nonapplicableCategories,
							'nonapplicableCategories'
						)}
					{!isDisabled && (
						<div className={`${styles.add}`} onClick={handleClick}>
							<AddOutlinedIcon
								fontSize='medium'
								color='primary'
								dataAttrs={{
									'data-type': 'nonapplicableCategories',
									'data-id': NonApplicableCategory,
									'data-name': 'nonapplicableCategories',
								}}
							/>
						</div>
					)}
				</div>

				<NonApplicableProdCategoryModal
					handleConfirm={handleConfirm}
					selectedCategoryList={[
						...fields.applicableCategories,
						...fields.nonapplicableCategories,
					]}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { data, show } = state.modal.nonapplicable_product_categories;
	return {
		show,
		data,
	};
};
const mapDispatchToProps = {
	toggleNonApplicableProductCategoriesModal:
		modalActions.toggleNonApplicableProductCategoriesModal,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NonApplicableCategory);
